// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { BdapCepDto, ResultDto } from '@ideapa/common-dto';
import { SelectItem } from '@ideapa/common-interfaces';
import { ParametriEstratti, ParametriInviati } from '@ideapa/common-utils';
import { map, Observable } from 'rxjs';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class BdapCepApiClient extends BaseCRUDApiClient<BdapCepDto> {
  baseUrl = this.config.apiEndpoint + '/bdap-cep';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  getTassonomie() {
    return this.http.get<SelectItem[]>(`${this.baseUrl}/tassonomie`);
  }

  importXbrlFile(file: File) {
    const fd = new FormData();
    fd.append('file', file);
    return this.http.post<ResultDto>(this.baseUrl + '/import-xbrl', fd);
  }

  downloadXbrl(
    parametriEstratti: ParametriEstratti,
    parametriInviati: ParametriInviati
  ): Observable<ArrayBuffer> {
    return this.http
      .post(
        this.baseUrl + '/download-xbrl',
        {
          parametriEstratti: parametriEstratti,
          parametriInviati: parametriInviati,
        },
        {
          responseType: 'arraybuffer',
        }
      )
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        })
      );
  }
}
